import React, { Fragment } from 'react';
import PropTypes from 'prop-types'
import Filter from "./Filter"
import FilterSale from './FilterSale';

const FabricFilters = ({
  isOpened,
  onFilterChange,
  activeFabricFilters,
  availableColorsHex,
  availableStylesText,
  onFilterClear,
  isMobile,
  onShowFilterClick,
  availablePatternsText,
  availableWeavesText,
  type,
}) => {

  if (!isOpened) {
    return null;
  }

  const handleStyleFilterChange = (filterValue, filterType, checked) => {
    onFilterChange(filterType, filterValue, checked)
  }

  let filters = (
    <Fragment>
      <Filter
        onCheck={handleStyleFilterChange}
        activeFabricFilters={activeFabricFilters.styles}
        variants={availableStylesText}
        filterName={'Стиль'}
        filterType='styles'
        onFilterClear={() => onFilterClear('styles')}
      />
      <Filter
        onCheck={handleStyleFilterChange}
        activeFabricFilters={activeFabricFilters.colors}
        variants={availableColorsHex}
        filterName={'Цвет'}
        filterType='colors'
        colorPicker
        onFilterClear={() => onFilterClear('colors')}
        isMobile={isMobile}
      />
      <Filter
        onCheck={handleStyleFilterChange}
        activeFabricFilters={activeFabricFilters.patterns}
        variants={availablePatternsText}
        filterName={'Рисунок'}
        filterType='patterns'
        styled={true}
        onFilterClear={() => onFilterClear('patterns')}
      />
      <FilterSale
        onCheck={handleStyleFilterChange}
        activeFabricFilters={activeFabricFilters.sale}
        filterName={'Sale'}
        filterType='sale'
        styled={true}
        onFilterClear={() => onFilterClear('sale')}
      />
      <Filter
        onCheck={handleStyleFilterChange}
        activeFabricFilters={activeFabricFilters.weaves}
        variants={availableWeavesText}
        filterName={'Тип плетения'}
        filterType='weaves'
        styled={true}
        onFilterClear={() => onFilterClear('weaves')}
      />
    </Fragment>
  );

  let content = (
    <div className='config-options-wrapper__mobile-filter-wrap'>
      <button
        className='config-options-wrapper__apply-filters-button'
        onClick={onShowFilterClick}>
        ПРИМЕНИТЬ
      </button>
      <div className='config-options-wrapper__filters'>
        {filters}
      </div>
    </div>
  );

  if (!isMobile) {
    content = (
      <div className={type === 'builder' ?
        'config-options-wrapper__left-menu' :
        'b-rit-catalog__filter-wrapper'}
      >
        {filters}
      </div>
    );
  }

  return (
    <Fragment>
      {content}
    </Fragment>
  );
}

FabricFilters.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  activeFabricFilters: PropTypes.object.isRequired,
  availableColorsText: PropTypes.array.isRequired,
  availableColorsHex: PropTypes.array.isRequired,
  availableStylesText: PropTypes.array.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onShowFilterClick: PropTypes.func.isRequired,
  availablePatternsText: PropTypes.array.isRequired,
  availableWeavesText: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
}

FabricFilters.defaultProps = {
  activeFabricFilters: {
    styles: {},
    colors: {},
    prints: {},
    weaves: {},
    sale: {},
  }
}

export default FabricFilters;
